import * as Sentry from '@sentry/react';
import { supabase } from './shared/api/supabase-client';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { installStaleChunkReload } from './shared/lib/reloadOnStaleChunk';
import { installBackendAuth } from './shared/lib/backendAuth';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

// После Sentry.init, чтобы сбой загрузки чанка попал и в отчёты об ошибках.
installStaleChunkReload();
// До первого рендера: бэкенд требует вход на всех /api/*.
installBackendAuth();

supabase.auth.onAuthStateChange((_event, session) => {
  if (session?.user) {
    Sentry.setUser({ id: session.user.id, email: session.user.email });
  } else {
    Sentry.setUser(null);
  }
});

createRoot(document.getElementById('root')!).render(<App />);
  